export const DEFAULT_CURRENCY = {
  symbol: 'S/',
  id: 'PEN',
};
